import { actionTooltipProps } from "@/ds";

/** Tags que cabem numa linha dos 224px úteis do card (100, 101, 102, 103, 105); com mais, o bloco quebra de linha. */
export const TIPO_OBRA_TAGS_POR_LINHA = 5;

export const TIPO_OBRA_SEM_VALOR = "—";

/** Tooltip "código · tipo" das tags; o texto vem do `data-pr-tooltip` de cada alvo. */
const { content: _content, ...tooltipProps } = actionTooltipProps("");

export const TIPO_OBRA_TOOLTIP_PROPS = tooltipProps;
